import { ff } from '@atlassian/jira-feature-flagging';
import { RetroTypes, type State } from './types';

// eslint-disable-next-line jira/ff/no-module-level-eval
const isEwbEnabled = ff('sprint-completion-ewb');

export const initialState: State = {
	sprintId: undefined,
	shouldCreateRetro: false,
	loadCreateRetroModal: false,
	loadCrossFlowModal: false,
	loadCrossJoinModal: false,
	isRetroLinked: false,
	isRetroLinking: false,
	isRetroPublished: false,
	isWhiteboardsDisabled: false,
	retroLinkingError: undefined,
	retroType: isEwbEnabled ? RetroTypes.WHITEBOARD : RetroTypes.PAGE,
	confluenceData: {
		spaceKey: undefined,
		parentPageId: undefined,
		spaceId: undefined,
	},
	createRetroPage: {
		data: undefined,
		loading: false,
		error: undefined,
	},
	createWhiteboard: {
		data: undefined,
		loading: false,
		error: undefined,
	},
};
